import React from 'react';
import GroupOwnerView from './GroupOwnerView';
import GroupParticipantView from './GroupParticipantView';

const GroupDetails = ({ group, updatedGroupId, switchToEditMode, venueId }) => {
  const isMultiVenueOwner = group.venueId === venueId;
  if (!isMultiVenueOwner) {
    return <GroupParticipantView group={group} />;
  } else {
    return (
      <GroupOwnerView
        group={group}
        expanded={group._id === updatedGroupId}
        switchToEditMode={switchToEditMode}
      />
    );
  }
};

export default GroupDetails;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MultiVenue/components/GroupDetails/index.jsx